<!-- src/views/pages/hrm/attendance/training/training-table.vue -->
<template>
  <a-table
    class="table datatable thead-light"
    :columns="columns"
    :data-source="rows"
    :loading="loading"
    row-key="id"
    :row-selection="rowSelection"
  >
    <template #bodyCell="{ column, record }">
      <template v-if="column.key === 'type'">
        {{ record?.training_type?.type || '-' }}
      </template>

        <template v-else-if="column.key === 'trainer'">
        <div class="d-flex align-items-center file-name-icon">
          <DqAvatar
            :src="record?.trainer?.photo_url || record?.trainer?.avatar_url || ''"
            :name="trainerName(record)"
            size-class="avatar-md"
            shape-class="rounded-circle"
            class="me-2"
          />
          <div class="ms-1">
            <h6 class="fw-medium mb-0">{{ trainerName(record) }}</h6>
            <small class="text-muted">{{ record?.trainer?.email }}</small>
          </div>
        </div>
      </template>

      <template v-else-if="column.key === 'employee'">
        {{ employeeName(record) }}
      </template>

      <template v-else-if="column.key === 'duration'">
        {{ duration(record) }}
      </template>

      <template v-else-if="column.key === 'cost'">
        {{ record?.training_cost ?? '-' }}
      </template>

      <template v-else-if="column.key === 'status'">
        <span class="badge badge-success d-inline-flex align-items-center badge-xs">
          <i class="ti ti-point-filled me-1"></i>{{ record?.status || '-' }}
        </span>
      </template>

      <template v-else-if="column.key === 'action'">
        <div class="action-icon d-inline-flex">
          <a href="javascript:void(0);" class="me-2" @click="$emit('edit', record)" v-can="'Training.Edit'">
            <i class="ti ti-edit"></i>
          </a>
          <a href="javascript:void(0);" @click="$emit('delete', record)" v-can="'Training.Delete'">
            <i class="ti ti-trash"></i>
          </a>
        </div>
      </template>
    </template>
  </a-table>
</template>

<script setup>
import { computed, ref } from "vue";
import DqAvatar from "@/components/shared/DqAvatar.vue";

const props = defineProps({
  rows: { type: Array, default: () => [] },
  loading: { type: Boolean, default: false },
  showEmployeeColumn: { type: Boolean, default: true },
});
const emit = defineEmits(["edit", "delete", "bulk-delete"]);

const selectedRowKeys = ref([]);

const baseColumns = [
  { title: "Training Type", dataIndex: "training_type", key: "type" },
  { title: "Trainer", dataIndex: "trainer", key: "trainer" },
  { title: "Employee", dataIndex: "employee", key: "employee" },
  { title: "Time Duration", dataIndex: "duration", key: "duration" },
  { title: "Description", dataIndex: "description", key: "description" },
  { title: "Cost", dataIndex: "training_cost", key: "cost" },
  { title: "Status", dataIndex: "status", key: "status" },
  { title: "", dataIndex: "action", key: "action" },
];

const columns = computed(() =>
  props.showEmployeeColumn
    ? baseColumns
    : baseColumns.filter((column) => column.key !== "employee")
);

const rowSelection = {
  selectedRowKeys: selectedRowKeys.value,
  onChange: (keys) => {
    selectedRowKeys.value = keys;
  },
  onSelect: () => {},
  onSelectAll: () => {},
};

function trainerName(r) {
  if (!r?.trainer) return "-";
  const t = r.trainer;
  return [t.first_name, t.last_name].filter(Boolean).join(" ") || "-";
}
function employeeName(r) {
  const u = r?.employee?.user;
  if (!u) return "-";
  return [u.first_name, u.last_name].filter(Boolean).join(" ");
}
function duration(r) {
  const s = r?.training_start_date
    ? new Date(r.training_start_date).toLocaleDateString()
    : "-";
  const e = r?.training_end_date
    ? new Date(r.training_end_date).toLocaleDateString()
    : "-";
  return `${s} - ${e}`;
}

// keyboard delete (bulk)
window.addEventListener("keydown", (e) => {
  if (e.key === "Delete" && selectedRowKeys.value.length) {
    emit("bulk-delete", selectedRowKeys.value);
  }
});
</script>
